












import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ToggleSwitch extends Vue {
  @Prop([String, Number]) readonly id!: string | number;
  @Prop([String, Number, Boolean]) readonly value!: string | number | boolean;
  @Prop(Boolean) readonly checked!: boolean;
  @Prop(String) readonly label!: string;
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop(Boolean) readonly isLoading!: boolean;

  onChange(val: boolean) {
    this.$emit('input', val);
    this.$emit('change', val);
  }
}
